import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FaMusic, FaEdit, FaTrash } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import Swal from 'sweetalert2';

import { deleteSound } from 'redux/actions';

import Paths from 'paths';

class Sound extends Component{

    render() {
        let imageUrl = this.props.imageUrl !== undefined ? this.props.imageUrl.url : false,
            soundUrl = this.props.soundUrl !== undefined ? this.props.soundUrl.url : false;
                        
        return (
            <div className={'soundbox-grid-sound'}>
                <div className={'soundbox-grid-sound-id'}>
                    <img src={imageUrl ? imageUrl : undefined} alt={`${this.props.sound.id}`} title={`${this.props.sound.id}`} className={imageUrl ? '' : 'not-found'}/>
                    <span>#{this.props.sound.id}</span>
                </div>
                <div className={'soundbox-grid-sound-movie'}>
                    <span>{this.props.sound.movie}</span>
                </div>
                <div className={'soundbox-grid-sound-characters'}>
                    <span>{this.props.sound.characters.join(', ')}</span>
                </div>
                <div className={'soundbox-grid-sound-timing'}>
                    <span>{this.props.sound.timing}</span>
                </div>
                <div className={'soundbox-grid-sound-title'}>
                    {this.props.sound.title}
                </div>
                <div className={'soundbox-grid-sound-play' + (soundUrl ? '' : ' not-found')} onClick={this.clickPlaySound}><FaMusic/></div>
                <div className={'soundbox-grid-sound-quote'}>
                    <textarea ref={input => this.quote = input} defaultValue={this.props.sound.quote} readOnly></textarea>
                </div>
                <NavLink className={'soundbox-grid-sound-edit'} to={Paths.PATH_ADMIN_EDIT_SOUND.replace(':soundboxId',this.props.soundbox.id).replace(':soundId',this.props.sound.id)}><FaEdit /></NavLink>
                <div className={'soundbox-grid-sound-delete'} onClick={this.aprooveDelete}><FaTrash /></div>
            </div>
        )
    }

    aprooveDelete = () => {
        Swal.fire({
            title: `Suppression du son ${this.props.sound.id}`,
            text: 'Etes vous vraiment sûr ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui !'
        }).then((result) => {
            if (result.value) {
                this.props.deleteSound(
                    this.props.soundbox.id,
                    this.props.sound.id
                );
            }
        })
    }

    clickPlaySound = () => {
        if(this.props.soundUrl === undefined) {
            Swal.fire({
                title: 'Son manquant ?',
                text: `Ce son n'a pas été trouvé !`,
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        } else {
            try {
                let audio = new Audio(this.props.soundUrl.url);
                audio.play();
            } catch(e) {
                console.log(e);
            };
        }
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteSound: (soundboxId, id) => {
            dispatch(deleteSound(soundboxId, id))
        }
    }
}

export default connect(null, mapDispatchToProps)(Sound);
